// extracted by mini-css-extract-plugin
export var actionButton = "_fm-0";
export var fileInput = "_fm-2";
export var paperclip = "_fm-1";